/**
 * Key used to store the active custom branding theme in localStorage.
 */
export const ACTIVE_CUSTOM_THEME_KEY = "activeCustomBrandingTheme";
const DEFAULT_THEME_ID = "DEFAULT_THEME";
export const isDefaultThemeActive = () => {
    return localStorage.getItem(ACTIVE_CUSTOM_THEME_KEY) === DEFAULT_THEME_ID;
};
/** This function checks prevents the custom theme from being applied on dashboard. */
export const shouldApplyCustomStyle = () => {
    const isResidentExperience = window.location.pathname.includes("/admission/");
    return isResidentExperience && !isDefaultThemeActive();
};
